interface GetScheduleProps {
  disableAll?: boolean;
}

/**
 * Function to generate a working schedule based on given props.
 * @param {GetScheduleProps} - Props containing disableAll flag.
 * @returns {Array} - Array of working hours for each day of the week.
 */
export const getSchedule = ({ disableAll }: GetScheduleProps) => {
  //this array used as data for backend, don't translate this
  const daysOfWeek = [
    'Monday',
    'Tuesday',
    'Wednesday',
    'Thursday',
    'Friday',
    'Saturday',
    'Sunday',
  ];

  const workingHours = daysOfWeek.map((day) => {
    const isSaturday = day === 'Saturday';
    const isSunday = day === 'Sunday';
    return {
      day,
      isEnabled: isSaturday || isSunday || disableAll ? false : true,
      slots: [
        {
          startTime: '',
          endTime: '',
        },
      ],
    };
  });

  return workingHours;
};
